@if (getSliderItem(); as slide) {
<div [navbarColor]="slide.navBarColor ?? defaultNavbarColor" [ngStyle]="slideStyle()" class="keen-slider__slide slide"
  [id]="slideID">
  @if (getSlideImage(slide); as slideImage) {
  @if (slide.imageStyle !== "inline") {
  <div [ngClass]="'img-' + slide.imageStyle">
    <img [image]="slideImage" />
  </div>
  }
  }
  <div class="slide-content med-width">
    @if (getSlideImage(slide); as slideImage) {
    @if (slide.imageStyle == "inline") {
    <div [ngClass]="'img-' + slide.imageStyle">
      <img [image]="slideImage" />
    </div>
    }
    }
    @if (slide.title) {
    <h1 class="title" [fadeOnScroll]="hasTransparentNavbar()">
      {{ slide.title | translate }}
    </h1>
    }
    @if (slide.buttonText) {
    <button class="button large" [routerLink]="slide.buttonLink"
      [ngStyle]="{ borderColor: slide.textColor, color: slide.textColor }" [fadeOnScroll]="hasTransparentNavbar()">
      {{ slide.buttonText | translate }}
    </button>
    }
  </div>
</div>
}


@if (getProductCompact(); as product) {
<div [ngStyle]="slideStyle()" class="keen-slider__slide product-slide slide" [id]="slideID">
  @if (product.packageType == PackageType.series) {
  <app-series-compact [product]="product"></app-series-compact>
  }
  @if (product.packageType == PackageType.book) {
  <app-product-compact [product]="product"></app-product-compact>
  }
</div>
}


@if (getYumpuDoc(); as yumpuDoc) {
<div [ngStyle]="slideStyle()" class="keen-slider__slide yumpu-slide slide" [id]="slideID">
  <app-yumpu-viewer class="max-width" [magazineId]="yumpuDoc.yumpuID"></app-yumpu-viewer>
</div>
}


@if (getCoverImage(); as coverImage) {
<div [ngStyle]="slideStyle()" class="keen-slider__slide cover-container slide" [id]="slideID">
  @if (coverImage.urls.length > 0) {
  <img class="cover" [image]="coverImage" [largeImage]="true" [style.objectFit]="'contain'" />
  }
  @if (coverImage.urls.length == 0) {
  <app-cover-placeholder [style.aspectRatio]="0.75" />
  <!-- <app-cover-placeholder [style.aspectRatio]="coverImage.aspectRatio" /> -->
  }
</div>
}


<!-- <ng-container [ngTemplateOutlet]="getTemplateRef()"></ng-container> -->